import { render, staticRenderFns } from "./PositionConfiguration.vue?vue&type=template&id=e524c4c2&"
import script from "./PositionConfiguration.vue?vue&type=script&lang=js&"
export * from "./PositionConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports